/* eslint-disable max-len */
import React from 'react';


const BookmarkIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      className={className}>
      <path fill="none" stroke="#383434" strokeWidth="2" d="M10.75 7h10.5c.966 0 1.75.784 1.75 1.75V24.5l-7-3.47-7 3.47V8.75C9 7.784 9.784 7 10.75 7z" />
    </svg>
  );
};

const ReadingIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      className={className}>
      <path fill="none" stroke="#383434" strokeWidth="2" d="M8 9l8 3.2L24 9v10.523a1 1 0 0 1-.629.928l-6.628 2.652a2 2 0 0 1-1.486 0L8.63 20.45a1 1 0 0 1-.63-.927V9z" />
    </svg>
  );
};

const FlagIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      className={className}>
      <path d="M9 20.006V7h15l-3.2 6.4 3.2 6.606zm0 5.957V7.002" fill="none" stroke="#383434" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </svg>
  );
};

const CloudIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      className={className}>
      <path fill="none" stroke="#383434" strokeWidth="2" d="M23.018 15.451c-.02 0-.037.005-.058.005-.3-3.425-3.144-6.123-6.648-6.123-3.071 0-5.631 2.077-6.426 4.893-.094-.005-.183-.027-.28-.027a4.273 4.273 0 1 0 0 8.547h13.412a3.648 3.648 0 0 0 0-7.295" />
    </svg>
  );
};

const AudioIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      className={className}>
      <path d="M8.212 18.37C6.92 18.642 6 19.733 6 20.993v.09c0 1.242.918 2.313 2.197 2.562l1.796.35v-6l-1.78.375h-.001zm1.35-2.328a2 2 0 0 1 2.431 1.953v6.011a1.998 1.998 0 0 1-2.4 1.96L7.796 25.6C5.586 25.147 4 23.492 4 21.237v-.094a4.821 4.821 0 0 1 3.78-4.707l1.781-.394h.001zm16.431 4.951v.09c0 1.242-.918 2.313-2.197 2.562l-1.796.35v-6l1.78.375c1.293.272 2.213 1.363 2.213 2.623zm-3.561-4.95A2 2 0 0 0 20 17.995v6.043a2 2 0 0 0 2.4 1.96l1.797-.368c2.21-.452 3.796-2.138 3.796-4.393v-.094a4.821 4.821 0 0 0-3.78-4.707l-1.781-.394v.001z" fill="#383434" />
      <path d="M9.014 15.995v1.015H7.022v-1.015C7.022 10.072 10.081 6 16.017 6c5.937 0 8.995 4.266 8.995 9.995v1.015h-1.859v-1.015c0-4.046-2.057-8-7.136-8-5.079 0-7.003 3.775-7.003 8z" fill="#383434" />
    </svg>
  );
};

const AllBooksIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 26 26"
      width="32"
      height="32">
      <g fill="#383434">
        <rect width="4" height="13" x="4" y="7" rx="1" />
        <rect width="4" height="17" x="10" y="3" rx="1" />
        <rect width="4" height="17" x="15" y="3" rx="1" transform="rotate(-15 17 11.5)" />
      </g>
    </svg>
  );
};

const LockedBooksIcon = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 16 16"
      width="32"
      height="32">
      <g fill="none" stroke="#383434">
        <path fill="#383434" d="M4 7h8a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z" />
        <path stroke="#383434" strokeWidth="1.5" d="M5 5a3 3 0 1 1 6 0v4" />
      </g>
    </svg>
  );
};

export { BookmarkIcon, FlagIcon, ReadingIcon, CloudIcon, AudioIcon, AllBooksIcon, LockedBooksIcon };
